module.exports = "/_next/static/images/Cover-e90fc08f6ab940d33301d6d85fe53725.webp";